// extracted by mini-css-extract-plugin
module.exports = {"container":"StoreIcon_container__MDBOC"};